<div class="exit-form-wrapper p-3">
  <h4 [innerHTML]="this.errorsService.errorTitle"></h4>
  <p class="mb-0" [innerHTML]="this.errorsService.errorMessage"></p>
</div>
